<template>
  <v-container fluid>
    <v-progress-circular
      v-if="loading"
      color="secondary"
      indeterminate
      absolute
      class="loader"
      width="3"
    ></v-progress-circular>
    <div class="swagger" id="swagger"></div>
  </v-container>
</template>

<script>
import SwaggerUI from "swagger-ui";
import axios from "axios";

const swaggerUI = SwaggerUI;

export default {
  name: "APIDocs",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      loading: true,
      serverUrl: process.env.VUE_APP_API_URL,
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.initSwagger();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    initSwagger() {
      this.loading = true;
      axios.get(`${this.serverUrl}/docs/`).then((r) => {
        swaggerUI({
          spec: r.data,
          dom_id: "#swagger",
          docExpansion: "none",
        });
        this.loading = false;
      });
    },
  },
};
</script>

<style>
@import "../assets/styles/swagger-ui.css"; /* optional  styles */

.swagger-ui .try-out__btn {
  display: none;
}
.loader {
  position: absolute;
  opacity: 1 !important;
  top: 40%;
  left: 50%;
}
</style>
